const formatNumber = (number: number, digitLength: number): string => {
  let s = number + '';
  while (s.length < digitLength) s = `0${s}`;
  return s;
}

export default formatNumber;
